module.exports = __webpack_public_path__ + "static/media/btn.28a0f6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/btn.png
// module id = 1110
// module chunks = 0